import { Context } from '@vue-storefront/core';

export const login = async (
  context: Context,
  {
    username,
    password,
    isRememberMe
  }: { username: string; password: string; isRememberMe?: boolean }
): Promise<any> => {
  const {
    $sapcc: {
      api: { OAuthUserAuthorization }
    }
  } = context;

  return OAuthUserAuthorization({
    username,
    password,
    isRememberMe
  });
};
